const ACCESSIBILITY_LINK_SELECTOR = 'a[href="#accessibility"]';

export class AccessibilityLink {
  initialize = () => {
    document.querySelectorAll(ACCESSIBILITY_LINK_SELECTOR).forEach((linkElement) => {
      linkElement.dataset.acsbCustomTrigger = true;
    });
  };
}
